export default {
  error: 'Errore',
  sorry: 'Siamo spiacenti, abbiamo ricevuto il seguente errore',
  workingOnIt:
    'Un ingegnere è stato informato di questo problema e stiamo lavorando per risolverlo il più rapidamente possibile.',
  tryAgain: 'Per favore riprova più tardi',
  noInternet:
    'Sembra che ci sia un problema con la tua connessione internet. Si prega di verificare e riprovare.',
}
